export default class PodcastAsset {
  constructor(obj, type) {
    this.imageUrl = obj.image_url
    this.linkId = obj.link.id
    this.subTitle = obj.subtitle
    this.title = obj.title

    if (type === 'podcastHero') {
      this.coverComp = 'PodcastHeroCover'

      this.type = 'podcastHero'
    } else {
      this.coverComp = 'PodcastCover'

      this.type = 'podcast'
    }
  }
}
